import { NetworkLoader } from './NetworkLoader';

export enum ELoadingState {
  UNKNOWN = 'unknown',
  LOADING = 'loading',
  LOADED = 'loaded',
  ABORTED = 'aborted',
  ERROR = 'error',
  DESTROYED = 'destroyed',
}

export interface INetworkLoaderConfig {
  url: URL;
  autoLoad: boolean;
  mode: 'text' | 'arrayBuffer';
  onStateChanged: (prevState: ELoadingState, nextState: ELoadingState, instance: NetworkLoader) => void;
  loadingTimeout?: number;
  maxRetries?: number;
  baseRetryTimeout?: number;
  workerMode?: boolean;
  requestCustomReferer?: string;
}

export interface INetworkError {
  status: number;
  statusText: string;
}

export type TNetworkResponseSimplified = {
  url: string;
  realUrl?: string;
  status?: number;
  body: string | ArrayBuffer | null;
  timestamp: number;
};

export type TChangeStateMetadata = {
  status?: number;
  realUrl?: string;
};
